const theme = {
  white: '#ffffff',
  black: '#505050',
  blue: '#1eb6ff',
  orange: '#ff992c',
  red: '#ff4e72',
  yellow: '#feec2d',
  green: '#11d17d',
  gray: '#b9b9b9',
  lightGray: '#f5f5f5',
};

export default theme;
